import styles from "./Error.module.scss";

const Error = () => {
    return <p className={styles.positionCenter}>Something wrong, please try later...</p>;
};
export default Error;
